import React from 'react';
import css from './update_backup_disk.module.scss';
import Chip from "@material-ui/core/Chip";
import Tooltip from "@material-ui/core/Tooltip";
import 'react-slideshow-image/dist/styles.css'
import SaveDataMocket from "../../../assets/images/projectsImage/backup.jpg";


const UpdateBackupDisk: React.FC = () => (
    <div className={css.project} id="update_backup_disk">
        <img src={SaveDataMocket} alt=""/>

        <div className={css.projectInformationContainer}>
            <div className={css.projectName} style={{position: 'relative'}}>
                <h3>Update Backup Disk</h3>
            </div>

            <div className={css.info}>
                <Chip label="2018" variant="outlined" size='small'/>
            </div>
            <div className={css.infoSmallScreen}>
                <Chip label="2018" variant="outlined" size='small'/>
            </div>

            <h5 className={css.textSectionInfo}>Description:</h5>
            <p className={css.description}>It is a simple script to update your backup hard disk from your workstation hard disk.</p>

            <div className={css.learnMoreLink}>
                <p>Source Code: <a className={css.link}
                                   href='https://github.com/adhess/update_backup_disk'
                                   rel="noopener noreferrer"
                                   target="_blank">https://github.com/adhess/update_backup_disk</a>
                </p>
            </div>

            <h5 className={css.textSectionInfo}>Keywords:</h5>
            <div className={css.keywords}>
                <Tooltip title="Script Bash">
                    <Chip label="Script Bash" color="primary" variant="outlined" size='small'/>
                </Tooltip>
            </div>

        </div>
    </div>
);

export default UpdateBackupDisk;
